var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner query-lcl-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.QueryLCLJobOrder2"),
        width: "1085px",
        "append-to-body": "",
        "close-on-click-modal": false,
        "before-close": _vm.beforeCloseHandler
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c("search-item", {
            ref: "searchItem",
            attrs: {
              "config-module": "202",
              reset: true,
              "show-simple": false,
              "expand-adv": true,
              "custom-search-items": _vm.customSearchItems,
              "col-settings": { span: 8 },
              "grid-config-module": "201002"
            },
            on: {
              advSearchItemCallBack: _vm.toQuery,
              perConfigChange: function(value) {
                _vm.perConfigName = value
              },
              refreshGrid: function() {
                _vm.gridRefreshId += 1
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "300px" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData,
              "per-config-name": _vm.perConfigName,
              "refresh-id": _vm.gridRefreshId,
              "config-module": "201002"
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("span", [
            _c("b", [
              _vm._v(
                _vm._s(_vm.$t("SeaExport.QuantityOfSelectedOrder")) +
                  "：" +
                  _vm._s(_vm.selectedRows.length)
              )
            ])
          ]),
          _c(
            "div",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Add3")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.beforeCloseHandler(function() {
                        _vm.innerVisible = false
                      })
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }